import { selectSingle, isEmptyValue, clearElement } from './LegacyModeStrategy.js';

class IndexlistModeStrategy {
    constructor(context) {
        this.context = context;
        this.mode = "indexlist";
    }
    onChange() {
        this.syncDataValueFromDisplay();
        this.context.emitComboChange();
    }
    onSelect(item, index) {
        selectSingle(this.context, item, index);
    }
    getValue() {
        const encoded = this.context.element.getAttribute("data-value")?.trim() ?? "";
        if (!encoded)
            return null;
        const values = [];
        encoded.replace(/\{([^}]*)\}/g, (_match, value) => {
            values.push(String(value));
            return "";
        });
        return values.length ? values : null;
    }
    setValue(value) {
        if (isEmptyValue(value)) {
            clearElement(this.context.element);
            return true;
        }
        const values = Array.isArray(value)
            ? value.map(String)
            : this._parse(String(value));
        const encoded = this._encode(values);
        this.context.element.setAttribute("data-value", encoded);
        if (this.context.element instanceof HTMLTextAreaElement) {
            this.context.element.value = values.map(item => `[${item}]`).join("\n");
            this.context.element.setAttribute("data-title", this.context.element.value);
        }
        return true;
    }
    hasValue() {
        return (this.context.element.getAttribute("data-value") ?? "") !== "";
    }
    getValueTitle() {
        const title = this.context.element.getAttribute("data-title")?.trim() ?? "";
        if (title)
            return title;
        const value = this.getValue();
        return value?.join(", ") ?? null;
    }
    syncDataValueFromDisplay() {
        const matches = this.context.element.value.match(/\[(\d+)\]/gm) ?? [];
        const encoded = matches
            .map(value => `{${value.substring(1, value.length - 1)}}`)
            .join("");
        this.context.element.setAttribute("data-value", encoded);
    }
    _encode(values) {
        return values
            .map(value => String(value).trim())
            .filter(Boolean)
            .map(value => `{${value}}`)
            .join("");
    }
    _parse(value) {
        const trimmed = value.trim();
        if (!trimmed)
            return [];
        const encoded = [...trimmed.matchAll(/\{([^}]*)\}/g)]
            .map(match => match[1].trim())
            .filter(Boolean);
        if (encoded.length)
            return encoded;
        return (trimmed.match(/[^\s,;]+/g) ?? []).map(item => item.trim()).filter(Boolean);
    }
}

export { IndexlistModeStrategy };
